import { QueryWrapper } from "../components";

/**
 * @deprecated use `QueryWrapper` instead - it looks like a hook but it isn't!
 */
export const useHandleQuery = QueryWrapper;
